export const colors = {
  charcoalblue: "#293036",
  darkcharcoal: "#22282E",
  green: "#3C9C75",
  lightsilver: "#D4D6D7",
};
